<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-md-12 px-1" v-if="statusSnack.snack">
        <v-snackbar
          v-model="statusSnack.snack"
          :timeout="3000"
          :color="statusSnack.snackColor"
        >
          {{ statusSnack.snackText }}
          <v-btn text @click="resetStatusSnack()">Close</v-btn>
        </v-snackbar>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9 px-1">
        <p>
        Select the <a target="_blank" title="Dynamic Course Schedule" href="https://go.uis.edu/ds">courses</a> in which you would like to enroll from the left and
          drag them to the field on the right. Click Save Selections when
          finished. <a href="#comments">Go to the Comments section</a> to ask
          your advisor a question.
        </p>
      </div>
      <div class="col-md-3 px-1">
	<select
          class="custom-select custom-select-md"
          v-model="selectedTerm"
          @change="setSelectedterm($event)"
        >
          <option value="">Select Term</option>
          <option :value="termList.current_semester">
            {{ termList.current_semester_name }}
          </option>
          <option :value="termList.additional_semester">
            {{ termList.additional_semester_name }}
          </option>
          <option :value="termList.alternate_semester">
            {{ termList.alternate_semester_name }}
          </option>


		  <option :value="termList.additional_semester_f25">
            {{ termList.additional_semester_name_f25 }}
          </option>

          <option :value="termList.additional_semester_su25">
            {{ termList.additional_semester_name_su25 }}
          </option>
          

    	  <option :value="termList.additional_semester_s25">
            {{ termList.additional_semester_name_s25 }}
          </option>
		  <option :value="termList.additional_semester_f24">
            {{ termList.additional_semester_name_f24 }}
          </option>
          <option :value="termList.additional_semester_su24">
            {{ termList.additional_semester_name_su24 }}
          </option>
    	  <option :value="termList.additional_semester_s24">
            {{ termList.additional_semester_name_s24 }}
          </option>
    	  <option :value="termList.additional_semester_f23">
            {{ termList.additional_semester_name_f23 }}
          </option>
          <option :value="termList.additional_semester_su23">
            {{ termList.additional_semester_name_su23 }}
          </option>
 	      <option :value="termList.additional_semester_s23">
            {{ termList.additional_semester_name_s23 }}
          </option>
          <option :value="termList.additional_semester_f22">
            {{ termList.additional_semester_name_f22 }}
          </option>
          <option :value="termList.additional_semester_su22">
            {{ termList.additional_semester_name_su22 }}
          </option>
 	      <option :value="termList.additional_semester_s22">
            {{ termList.additional_semester_name_s22 }}
          </option>
          <option :value="termList.additional_semester_f21">
            {{ termList.additional_semester_name_f21 }}
          </option>
          <option :value="termList.additional_semester_su21">
            {{ termList.additional_semester_name_su21 }}
          </option>
          <option :value="termList.additional_semester_s21">
            {{ termList.additional_semester_name_s21 }}
          </option>
          <option :value="termList.additional_semester_f20">
            {{ termList.additional_semester_name_f20 }}
          </option>
          <option :value="termList.additional_semester_su20">
            {{ termList.additional_semester_name_su20 }}
          </option>
     	  <option :value="termList.additional_semester_s20">
            {{ termList.additional_semester_name_s20 }}
          </option>
        </select>
      </div>
      <div class="col-md-12">
        <p>
          Course Legend:
          <v-chip class="px-2 py-0" color="#F3E5F5" text-color="black" label
            >First Half</v-chip
          >
          <v-chip class="px-2 py-0" color="#FFF3E0" text-color="black" label
            >Second Half</v-chip
          >
          <v-chip
            class="px-2 py-0"
            color="light-blue lighten-5"
            text-color="black"
	    href="https://www.uis.edu/registrar/course-schedules-catalogs/accelerated-courses"
	    target="_blank"
            label
            >Winter Intersession</v-chip>
          <v-chip class="px-2 py-0" color="#FFCDD2" text-color="black" label
            >No seats available</v-chip
          >
          <v-chip class="px-2 py-0" color="#FFFDE7" text-color="black" label
            >Less than 4 seats available</v-chip
          >

	 <v-checkbox v-if="csc_admin == 'true'" 
            v-model="hasCscFilters"
            label="CSC Filters"
            title="CSC Filters"
            class="px-2" />
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-4">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text"><b>Courses</b></span>
          </div>
          <input
            v-model="search"
            type="text"
            class="form-control"
            placeholder="Search"
          />
        </div>

        <v-card class="courselist" style="overflow-y: scroll">
          <v-list>
            <v-list-group v-if="groupedCourses['fys'] !== undefined">
              <template v-slot:activator>
                <v-list-item-title>FYS</v-list-item-title>
              </template>
              <template>
                <v-list-group
                  sub-group
                  v-for="(courses, gckey) in groupedCourses['fys']"
                  :key="'gcfys-' + gckey"
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>{{ gckey }}</v-list-item-title>
                    </v-list-item-content>
                  </template>

                  <draggable :list="courses" group="crs_subj_cd">
                    <div
                      v-for="element in courses"
                      :key="element.name"
                      :class="'list-group-item ' + generateCourseColor(element)"
                    >
                      {{ `${element.sect_title} ( ` }}
                      <a
                        target="_blank"
                        title="Course Information"
                        :href="
			  'https://apps.uis.edu/dynamic-course-schedule/' + element.term_cd + '/' + element.crn
                        "
                        onclick="return popup(this.href, 800, 1024);"
                        >{{
                          `${element.crs_subj_cd} ${element.crs_nbr} ${element.sect_nbr}`
                        }}</a>
                      {{ `- ${element.crn} - ${element.gened_attr_names} )` }}
			<br />
			<div>
		      {{ `${element.sect_credit_hours} credit${element.lecture_mode_day_time_instructor}` }}
		      <span v-if="isAdmin">|({{ `${element.tentative_course_count}` }})</span>
                    </div>
                   </div>
                  </draggable>
                </v-list-group>
              </template>
            </v-list-group>
            <v-list-group v-if="groupedCourses['online'] !== undefined">
              <template v-slot:activator>
                <v-list-item-title>Online</v-list-item-title>
              </template>
              <template>
                <v-list-group
                  sub-group
                  v-for="(courses, gckey) in groupedCourses['online']"
                  :key="'gconline-' + gckey"
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>{{ gckey }}</v-list-item-title>
                    </v-list-item-content>
                  </template>

                  <draggable :list="courses" group="crs_subj_cd">
                    <div
                      v-for="element in courses"
                      :key="element.name"
                      :class="'list-group-item ' + generateCourseColor(element)"
                    >
                      {{ `${element.sect_title} ( ` }}
                      <a
                        target="_blank"
                        title="Course Information"
			:href="
                          'https://apps.uis.edu/dynamic-course-schedule/' + element.term_cd + '/' + element.crn
                        "
                        onclick="return popup(this.href, 800, 1024);"
                        >{{
                          `${element.crs_subj_cd} ${element.crs_nbr} ${element.sect_nbr}`
                        }}</a>
		      {{ `- ${element.crn} - ${element.gened_attr_names} )` }}
		      <br />
		      <div>
		      {{ `${element.sect_credit_hours} credit${element.lecture_mode_day_time_instructor}` }}
		      <span v-if="isAdmin">|({{ `${element.tentative_course_count}` }})</span>
                      </div>
                    </div>
                  </draggable>
                </v-list-group>
              </template>
            </v-list-group>
            <v-list-group v-if="groupedCourses['gened'] !== undefined">
              <template v-slot:activator>
                <v-list-item-title>Gened</v-list-item-title>
              </template>
              <template>
                <v-list-group
                  sub-group
                  v-for="(gCourses, genedkey) in groupedCourses['gened']"
                  :key="'genedkey-' + genedkey"
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>{{ genedkey }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-group
                    sub-group
                    v-for="(courses, gckey) in gCourses"
                    :key="'gcgened-' + gckey"
                  >
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>{{ gckey }}</v-list-item-title>
                      </v-list-item-content>
                    </template>

                    <draggable :list="courses" group="crs_subj_cd">
                      <div
                        v-for="element in courses"
                        :key="element.name"
                        :class="
                          'list-group-item ' + generateCourseColor(element)
                        "
                      >
                        {{ `${element.sect_title} ( ` }}
                        <a
                          target="_blank"
                          title="Course Information"
			  :href="
                          'https://apps.uis.edu/dynamic-course-schedule/' + element.term_cd + '/' + element.crn
                          "
                          onclick="return popup(this.href, 800, 1024);"
                          >{{
                            `${element.crs_subj_cd} ${element.crs_nbr} ${element.sect_nbr}`
                          }}</a>
			  {{ `- ${element.crn} - ${element.gened_attr_names} )` }}
			                          <br />
                          <div>
                          {{ `${element.sect_credit_hours} credit${element.lecture_mode_day_time_instructor}` }}
                      <span v-if="isAdmin">|({{ `${element.tentative_course_count}` }})</span>
                    </div>
                   </div>
                  </draggable>
                  </v-list-group>
                </v-list-group>
              </template>
            </v-list-group>
            <v-list-group v-if="groupedCourses['ecce'] !== undefined">
              <template v-slot:activator>
                <v-list-item-title>ECCE</v-list-item-title>
              </template>
              <template>
                <v-list-group
                  sub-group
                  v-for="(gCourses, eccekey) in groupedCourses['ecce']"
                  :key="'eccekey-' + eccekey"
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>{{ eccekey }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-group
                    sub-group
                    v-for="(courses, gckey) in gCourses"
                    :key="'gcecce-' + gckey"
                  >
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>{{ gckey }}</v-list-item-title>
                      </v-list-item-content>
                    </template>

                    <draggable :list="courses" group="crs_subj_cd">
                      <div
                        v-for="element in courses"
                        :key="element.name"
                        :class="
                          'list-group-item ' + generateCourseColor(element)
                        "
                      >
                        {{ `${element.sect_title} ( ` }}
                        <a
                          target="_blank"
                          title="Course Information"
			  :href="
                          'https://apps.uis.edu/dynamic-course-schedule/' + element.term_cd + '/' + element.crn
                          "
                          onclick="return popup(this.href, 800, 1024);"
                          >{{
                            `${element.crs_subj_cd} ${element.crs_nbr} ${element.sect_nbr}`
                          }}</a>
			{{ `- ${element.crn} - ${element.gened_attr_names} )` }}
                        <br />
                        <div>
                      {{ `${element.sect_credit_hours} credit${element.lecture_mode_day_time_instructor}` }}
                      <span v-if="isAdmin">|({{ `${element.tentative_course_count}` }})</span>
                    </div>
                   </div>
                  </draggable>
                  </v-list-group>
                </v-list-group>
              </template>
            </v-list-group>
            <v-list-group
              v-for="(courses, subjectName) in groupedCourses['null']"
              :key="'nonfyskey-' + subjectName"
            >
              <template v-slot:activator>
                <v-list-item-title>{{ subjectName }}</v-list-item-title>
              </template>

              <draggable :list="courses" group="crs_subj_cd">
                <div
                  v-for="element in courses"
                  :key="element.name"
                  :class="'list-group-item ' + generateCourseColor(element)"
                >
                  {{ `${element.sect_title} ( ` }}
                  <a
                    target="_blank"
                    title="Course Information"
		    :href="
                    'https://apps.uis.edu/dynamic-course-schedule/' + element.term_cd + '/' + element.crn
                    "
                    onclick="return popup(this.href, 800, 1024);"
                    >{{
                      `${element.crs_subj_cd} ${element.crs_nbr} ${element.sect_nbr}`
                    }}</a>
		  {{ `- ${element.crn} - ${element.gened_attr_names} )` }}
                        <br />
                        <div>
                      {{ `${element.sect_credit_hours} credit${element.lecture_mode_day_time_instructor}` }}
                      <span v-if="isAdmin">|({{ `${element.tentative_course_count}` }})</span>
                    </div>
                   </div>
                  </draggable>
            </v-list-group>
          </v-list>
        </v-card>
      </div>

      <div class="col-sm-12 col-md-8">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text"
              ><b>UIN = {{ isAdmin == true ? searchUin : studentId }}</b></span
            >
          </div>
          <input
            v-if="isAdmin == true"
            v-model="searchUin"
            name="searchUin"
            type="text"
            class="form-control m-2 pb-"
            required=""
            @focus="onInputFocus()" 
            on
            placeholder="Search UIN or Last Name"
            autofocus
          />
          <div v-if="isAdmin == true" class="input-group-append">
            <button
              class="btn btn-outline-secondary"
              type="button"
              @click="getStudentDetails(searchUin)"
            >
              Search
            </button>
          </div>
        </div>
        <ul
          class="search-name-results list-group mb-3 p-0"
	  style="position: absolute; width: 97%; z-index: 2"
          v-if="results.length > 0"
        >
          <li
            class="list-group-item autocomplete-result"
            style="display: flex; align-items: center"
            v-for="(result, resultKey) in results"
            :key="resultKey"
            @click="setResult(result)"
          >
            <v-list-item-avatar
              color="indigo"
              class="headline font-weight-light white--text"
            >
              {{ result.stu_fname.charAt(0) }}
            </v-list-item-avatar>
            <div
              class="input-group-prepend"
              style="display: flex; flex-flow: column"
            >
              <span>{{ result.stu_fname }} {{ result.stu_lname }}</span>
              {{ result.uinid }}
            </div>
          </li>
        </ul>
        <draggable
          class="list-group p-1"
          :list="selections"
          group="crs_subj_cd"
        >
          <div
            :class="'list-group-item ' + generateCourseColor(element)"
            v-for="(element, index) in selections"
            :key="'selections-' + index"
          >
            <span v-if="element.sect_title"
              >{{ `${element.sect_title} ( `
              }}<a
                target="_blank"
                title="Course Information"
		:href="
                'https://apps.uis.edu/dynamic-course-schedule/' + element.term_cd + '/' + element.crn
                "
                onclick="return popup(this.href, 800, 1024);"
                >{{
                  `${element.crs_subj_cd} ${element.crs_nbr} ${element.sect_nbr}`
                }}</a>
	      {{ `) ${element.crn} - ${element.gened_attr_names}` }} </span>
            <span v-else
              ><div class="label alert alert-warning" role="alert">
                Course Cancelled
              </div>
                {{ `${element.cancelled_course_name}` }} </span>
            <br />
            <div v-if="element.sect_title">
	      {{ `${element.sect_credit_hours} credit${element.lecture_mode_day_time_instructor}` }}
            <span v-if="isAdmin">|({{ `${element.tentative_course_count}` }})</span>
            </div>
            <div>
              {{
                (exisitingSelections.length > index &&
                  exisitingSelections[index]["approved"]) == 1
                  ? "Advisor Accepted"
                  : "Pending Advisor Accept"
              }}
              <div v-if="exisitingSelections[index] === undefined"></div>
              <div v-else>
                <span
                  v-if="
                    isAdmin == true ||
                    (exisitingSelections.length > index &&
                      exisitingSelections[index]['approved'] != 1)
                  ">
			   <button class="btn btn-danger py-0 px-2" title="Delete Tentative Course"
                @click="deletetentcourse(exisitingSelections[index]['id'], index)">
                Delete
               </button>
                 </span>
              </div>
              <button title="Advisor Accept"
                v-if="isAdmin == true &&
                  exisitingSelections.length > index &&
                  exisitingSelections[index]['approved'] != 1 &&
		  !(exisitingSelections[index]['coursename'].includes('CSC') && !(exisitingSelections[index]['coursename'].includes('CSC 225') || exisitingSelections[index]['coursename'].includes('CSC 316')) && csc_admin == 'false')"
                class="btn btn-success py-0 px-2"
                @click="approveSelection(exisitingSelections[index]['id'])"
              >
                Advisor Accept
              </button>
            </div>
          </div>
        </draggable>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-4"></div>
      <div class="col-sm-12 col-md-8">
        <v-row v-if="this.studentId.length > 0">
          <v-col class="text-left">
            <div class="row">
              <div class="col-sm-12 col-md-5 px-4">
                <v-btn
                  class="btn btn-success pl-4"
                  @click="storeSelectedCourses()"
                  >Save Selections</v-btn
                >
              </div>
              <div class="col-sm-12 col-md-4 px-4">
                Total Credits: {{ totalCredits }}
              </div>
              <div class="col-sm-12 col-md-3" v-if="isAdmin == true">
                <v-checkbox
                  v-model="is_complete"
                  label="Advising Complete"
                  title="Lift traditional student advising hold"
                  class="pr-4"
                  :disabled="is_complete_disabled"
                  @change="updateHold()"
                />
              </div>

              <div class="col-sm-12 col-md-3" v-else>
                <div v-if="is_complete">
                  <v-chip
                    class="ma-2"
                    title="Advising has been completed for the selected semester. Please log into Enterprise after your time ticket is active and register for your courses."
                    color="teal"
                    text-color="white"
                  >
                    <v-avatar left>
                      <v-icon>check</v-icon>
                    </v-avatar>
                    Advising Completed
                  </v-chip>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<style>
.v-list-group.v-list-group--active.primary--text {
  color: rgba(0,0,0,.87) !important;
}
.courselist {
  border: 1px solid #ccc !important;
  min-height: 50vh;
  max-height: 50vh;
  overflow: auto;
  box-shadow: none;
}
.courselist .v-list-group {
  border-bottom: 1px solid #ccc;
}
.courselist
  .v-list-group__header.v-list-item.v-list-item--active.v-list-item--link.theme--light {
  border-bottom: 1px solid #ccc;
}
.courselist .v-list-group--sub-group .v-list-group__header {
  padding-left: 32px;
}
.courselist .v-list-item__icon.v-list-group__header__prepend-icon {
  display: none;
}
.full-section {
  background: #FFCDD2 !important;
  color: #000 !important;
}
.almost-full-section {
  background: #FFFDE7 !important;
  color: #000 !important;
}
.winter-intersession-section {
  background: #E1F5FE !important;
  color: #000 !important;
}
.first-half-section {
  background: #F3E5F5 !important;
  color: #000 !important;
}
.second-half-section {
  background: #FFF3E0 !important;
  color: #000 !important;
}
@media only screen and (max-width: 768px) {
  .row {
    display: flex !important;
    flex-flow: column wrap !important;
  }
}
</style>

<script>
import draggable from "vuedraggable";
import { mapState } from "vuex";

export default {
  components: {
    draggable,
  },
  data() {
    return {
      is_complete: false,
      hasCscFilters: true,
      is_complete_disabled: false,
      groupedCourses: [],
      groupedFysCourses: [],
      selections: [],
      results: [],
      searchUin: "",
      totalCredits: 0,
      search: "",
      registeredCoursesCurrentTerm: [],
      bannerMessage: "",
      isSetResult: false
    };
  },
  props: {
    lookupby: {
      type: String,
      required: false,
    },
    admin: {
      type: String,
      required: false,
    },
    csc_admin: {
      type: String,
      required: false,
    },
    lookupsemester: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapState({
      studentDetailsFromStore: (state) => state.student,
      termFromStore: (state) => state.term,
      coursesFromStore: (state) => state.courses,
      statusfromStore: (state) => state.status,
    }),
    isAdmin: {
      get() {
        return this.studentDetailsFromStore.isAdvisor;
      },
      set(newName) {
        return newName;
      },
    },
    studentDetails: {
      get() {
        return this.studentDetailsFromStore.details;
      },
      set(newName) {
        return newName;
      },
    },
    studentId: {
      get() {
        return this.studentDetailsFromStore.currentStudentUin;
      },
      set(newName) {
        return newName;
      },
    },
    selectedTerm: {
      get() {
        return this.termFromStore.selected;
      },
      set(newName) {
        if (newName !== "") {
          return newName;
        }
      },
    },
    termList: {
      get() {
        return this.termFromStore.all;
      },
      set(newName) {
        return newName;
      },
    },
    courses: {
      get() {
        return this.coursesFromStore.all;
      },
      set(newName) {
        return newName;
      },
    },
    exisitingSelections: {
      get() {
        return this.coursesFromStore.tentativeCourses;
      },
      set(newName) {
        return newName;
      },
    },
    created_by: {
      get() {
        return this.studentDetailsFromStore.isAdvisor == true
          ? this.studentDetailsFromStore.advisorUin
          : this.studentDetailsFromStore.currentStudentUin;
      },
      set(newName) {
        return newName;
      },
    },
    statusSnack: {
      get() {
        return this.statusfromStore;
      },
      set(newName) {
        return newName;
      },
    },
  },
  created() {
    this.initialize();
  },
  watch: {
    selectedTerm: function (val) {
      if (Object.keys(this.studentDetails).length > 0) {
        this.getCourses();
        this.getCompleted();
      }
    },
    hasCscFilters: function (val) {
      if (Object.keys(this.studentDetails).length > 0) {
        this.getCourses();
        this.getCompleted();
      }
    },
    studentDetails: function (val) {
      if (Object.keys(val).length > 0) {
        this.getCourses();
        this.getCompleted();
      }
    },
    searchUin(after, before) {
      if (after.length >= 2 && !this.isSetResult) {
        this.fetch();
      } else if (after.length <= 1) {
        this.results = "";
      }
    },
	selections: function (val) {
  const hasVariable = val.some(v => v.is_variable_credit);

  const total = val
    .filter(v => !v.is_variable_credit)
    .reduce((a, b) => +a + +b.sect_credit_hours, 0)
    .toFixed(2);

  this.totalCredits = hasVariable
    ? `${total} plus variable credit(s)`
    : total;
	},
    search: function (val) {
      if (this.studentDetails.mathplacement != "Unknown") {
        var search_result = this.courses.filter(
          (item) =>
            (item.crs_subj_cd + " " + item.crs_nbr)
              .toLowerCase()
              .includes(val.toLowerCase()) ||
            item.crn.toLowerCase().includes(val.toLowerCase()) ||
            item.sect_title.toLowerCase().includes(val.toLowerCase())
        );
        if (search_result.length > 0) {
          this.groupedCourses = this.generateCourseGrouping(search_result);
        } else {
          this.groupedCourses = this.generateCourseGrouping(this.courses);
        }
      }
    },
    statusSnack: function (val) {
      this.statusSnack = val;
    },
  },
  mounted() {
    this.getSemesters();
  },
  methods: {
    initialize() {
      if (this.admin == "true" && this.lookupby.length > 0) {
        this.searchUin = this.lookupby;
        this.getStudentDetails(this.searchUin);
	this.isSetResult = true;
      }
    },
    onInputFocus(){
      this.isSetResult = false
    },
    generateCourseColor(element) {
      //return ((parseInt(element.sect_actual_enrl) >= parseInt(element.sect_max_enrl)) ? 'full-section' : (parseInt(element.sect_max_enrl) <= (parseInt(element.sect_actual_enrl) + 4)) ? 'almost-full-section' : '');
      return element.part_of_term_desc == "First Half" 
        ? "first-half-section"
        : element.part_of_term_desc == "Second Half"
        ? "second-half-section"
        : element.part_of_term_desc == "Intersession"
        ? "winter-intersession-section"
        : parseInt(element.sect_actual_enrl) >= parseInt(element.sect_max_enrl)
        ? "full-section"
        : parseInt(element.sect_max_enrl) <=
          parseInt(element.sect_actual_enrl) + 4
        ? "almost-full-section"
        : "";
    },
    resetStatusSnack() {
      this.$store.commit("status/setStatus", {
        snack: false,
        snackColor: "",
        snackText: "",
      });
    },
    async fetch() {
      await axios
        .get("/api/v1/studentlookup", {
          params: { searchUin: this.searchUin },
        })
        .then((response) => {
          this.results = response.data;
        })
        .catch((error) => {
	if(error.response.status === 401)
                    {
      	this.$store.commit("status/setStatus", {
        snack: true,
        snackColor: "error",
        snackText: "Unauthorized - Please close your browser and log in again.",
      });
                    }
		});
    },
    async deletetentcourse(tentativecourseid, tentativecourseindex) {
      if (confirm("Are you sure you want to delete this saved selection?")) {
        await axios
          .delete(
            "/api/v1/deletetentcourse/" + tentativecourseid
          )
          .then((response) => {
            //  Event.$emit("current-term-schedule", this.studentId);
            this.$store.commit("status/setStatus", {
              snack: true,
              snackColor: "success",
              snackText: "Course selection removed",
            });
            this.exisitingSelections.splice(tentativecourseindex, 1);
            this.selections.splice(tentativecourseindex, 1);
          });
      }
    },
    setResult(result) {
      this.searchUin = result.uinid;
      this.isSetResult = true;
      if (result.uinid) {
        this.results = [];
        this.selections = [];
        this.exisitingSelections = [];
        this.courses = [];
        this.groupedCourses = [];
        this.$store.commit("student/setCurrentStudentUin", result.uinid);
      }
       
    },
    getStudentDetails(searchUin) {
      if (searchUin !== "") {
        this.results = [];
        this.selections = [];
        this.exisitingSelections = [];
        this.courses = [];
        this.groupedCourses = [];
        this.$store.commit("student/setCurrentStudentUin", searchUin);
      }
    },
    groupBy(OurArray, property) {
      return OurArray.reduce(function (accumulator, object) {
        const key = object[property];
        if (!accumulator[key]) {
          accumulator[key] = [];
        }
        accumulator[key].push(object);
        return accumulator;
      }, {});
    },
    groupByNew(array, f) {
      var groups = {};
      array.forEach(function (o) {
        var group = JSON.stringify(f(o));
        groups[group] = groups[group] || [];
        groups[group].push(o);
      });
      return Object.keys(groups).map(function (group) {
        return groups[group];
      });
    },
    sortCourses(obj) {
      let ordered = {};
      Object.keys(obj)
        .sort()
        .forEach((key) => {
          ordered[key] = obj[key].slice().sort(function (a, b) {
            return `${a.crs_nbr} ${a.sect_nbr}` < `${b.crs_nbr} ${b.sect_nbr}`
              ? -1
              : 1;
          });
        });
      return ordered;
    },
    filterCoursesByPlacements(courses) {  

      if (this.studentDetails.mathplacement) {
        let mathplacementStr = this.studentDetails.mathplacement;
        let courseName = mathplacementStr.split(" ")[0];
        let mathPlacements = mathplacementStr.split(" ")[1];
        let mathPlacementArr = mathPlacements.split("/");
        var filteredMathCourses = courses.filter(
          (arr) =>
            arr.crs_subj_cd == courseName &&
            //mathPlacementArr.some((e) => e == arr.crs_nbr)
            mathPlacementArr.some((e) => e == arr.crs_nbr || arr.crs_nbr >= 300)
        );
        //remove all math courses from the courses array and add latestmathcourses
        courses = courses.filter((arr) => arr.crs_subj_cd != courseName);
        courses = [].concat(courses, filteredMathCourses);
      }

      //filter all ENG except 091 if they did not place in it
      //if (this.studentDetails.needs_english_placement != 'No') {
      //  var filteredEng091Courses = courses.filter((arr) => (arr.crs_subj_cd == 'ENG') && (arr.crs_nbr != 101) && arr.crs_nbr != 102);
      //  courses = courses.filter((arr) => (arr.crs_subj_cd != 'ENG'));
      //  courses = [].concat(courses, filteredEng091Courses)
      //}

      //Commented on 10-17-25 - ENG 091 is no longer offered. Every student gets placed in ENG 101 - Sarah Collins
	  //if ((this.studentDetails.writeplacer == null) || (this.studentDetails.writeplacer > 3)) {
      //var filteredEng103104Courses = courses.filter((arr) => (arr.crs_subj_cd == 'ENG') && (arr.crs_nbr != 103) && arr.crs_nbr != 104);
      //courses = courses.filter((arr) => (arr.crs_subj_cd != 'ENG'));
      //courses = [].concat(courses, filteredEng103104Courses)
      //}

	  //if ((this.studentDetails.writeplacer != null) && (this.studentDetails.writeplacer < 4)) {
      //var filteredEng101Courses = courses.filter((arr) => (arr.crs_subj_cd == 'ENG') && (arr.crs_nbr != 101));
      //courses = courses.filter((arr) => (arr.crs_subj_cd != 'ENG'));
      //courses = [].concat(courses, filteredEng101Courses)
      //}

      //filter out CHE 141 if they did not place in it
      //if (this.studentDetails.needs_chemistry_placement != "No") {
      if (['Unknown', 'Yes'].includes(this.studentDetails.needs_chemistry_placement)) {
        var filteredChe141Courses = courses.filter(
          (arr) => arr.crs_subj_cd == "CHE" && arr.crs_nbr != 141
        );
        courses = courses.filter((arr) => arr.crs_subj_cd != "CHE");
        courses = [].concat(courses, filteredChe141Courses);
      }
      //filter out BIO 202 if they didnt pass BIO 201
      if (this.studentDetails.passed_bio_201 == false) {
        var filteredBio201Courses = courses.filter(
          (arr) => arr.crs_subj_cd == "BIO" && arr.crs_nbr != 202
        );
        courses = courses.filter((arr) => arr.crs_subj_cd != "BIO");
        courses = [].concat(courses, filteredBio201Courses);
      }
//#######################################################################################################
	if(this.hasCscFilters)
	{
      //CSC
      //Filter 500 level courses
	courses = courses.filter(
	(arr) => !(arr.crs_subj_cd == "CSC" && parseInt(arr.crs_nbr) >= 500)
	        );

      //filter out CSC 275 if they didnt have CSC 225
      if (!this.studentDetails.courses.includes('CSC 225')) {
        courses = courses.filter(
          (arr) => !(arr.crs_subj_cd == "CSC" && arr.crs_nbr == "275")
        );
      }

      //filter out CSC 302 if they didnt have ZZ_CSC302
      if (!this.studentDetails.courses.includes('ZZ_CSC302')) {
        courses = courses.filter(
          (arr) => !(arr.crs_subj_cd == "CSC" && arr.crs_nbr == "302")
        );
      }

      //filter out CSC 305 if they are not CSC Major
      //Commented out per Jeniffer Berry on 7-17-25
     /*
      if(this.studentDetails.studentRecord !== undefined)
      {
      if ((this.studentDetails.studentRecord.major1 === undefined || this.studentDetails.studentRecord.major1.description != "Computer Science") && (this.studentDetails.studentRecord.major2 === undefined || this.studentDetails.studentRecord.major2.description != "Computer Science")) {
        courses = courses.filter(
          (arr) => !(arr.crs_subj_cd == "CSC" && arr.crs_nbr == "305")
        );
      }
     }
     */
       //filter out Many if they didnt have CSC 275
      if (!this.studentDetails.courses.includes('CSC 275')) {
        courses = courses.filter(
          //(arr) => !(arr.crs_subj_cd == "CSC" && ['366', '368', '387', '452', '472'].includes(arr.crs_nbr))
          (arr) => !(arr.crs_subj_cd == "CSC" && ['366', '368', '387', '389', '452', '472'].includes(arr.crs_nbr))
        );
  }

      //filter out Many if they didnt have CSC 275 with section
      if (!this.studentDetails.courses.includes('CSC 275')) {
        courses = courses.filter(
	  //(arr) => !(arr.crs_subj_cd == "CSC" && arr.crs_nbr == "470" && ['D', 'H', 'I'].includes(arr.sect_nbr))
          (arr) => !(arr.crs_subj_cd == "CSC" && arr.crs_nbr == "470" && ['F', 'H', 'I'].includes(arr.sect_nbr))
        );
      }

	//filter out CSC 376
      //if (!(this.studentDetails.courses.includes('CSC 275') && this.studentDetails.courses.includes('CSC 302'))) {
      if (!(this.studentDetails.courses.includes('CSC 275'))) {
        courses = courses.filter(
          (arr) => !(arr.crs_subj_cd == "CSC" && arr.crs_nbr == "376")
        );
      }

	//filter out CSC 385 
      if (!(this.studentDetails.courses.includes('CSC 275') && this.studentDetails.courses.includes('CSC 302') && this.studentDetails.courses.includes('MAT 121') && (this.studentDetails.courses.includes('MAT 113') || this.studentDetails.courses.includes('MAT 115')))) {
        courses = courses.filter(
          (arr) => !(arr.crs_subj_cd == "CSC" && arr.crs_nbr == "385")
        );
      }

	//filter out CSC 388 if they didnt have CSC 385
      if (!this.studentDetails.courses.includes('CSC 385')) {
        courses = courses.filter(
          (arr) => !(arr.crs_subj_cd == "CSC" && arr.crs_nbr == "388")
        );
      }

	//filter out CSC 389 
      //if (!(this.studentDetails.courses.includes('CSC 275') && this.studentDetails.courses.includes('CSC 302') && this.studentDetails.courses.includes('MAT 121') && this.studentDetails.courses.includes('CSC 376') && this.studentDetails.courses.includes('CSC 385') && (this.studentDetails.courses.includes('MAT 113') || this.studentDetails.courses.includes('MAT 115')))) {
      if (!(this.studentDetails.courses.includes('CSC 275') && this.studentDetails.courses.includes('CSC 302') && this.studentDetails.courses.includes('MAT 121') && (this.studentDetails.courses.includes('MAT 113') || this.studentDetails.courses.includes('MAT 115')))) {
        courses = courses.filter(
          (arr) => !(arr.crs_subj_cd == "CSC" && arr.crs_nbr == "389")
        );
      }

       //filter out CSC 405 if not senior
      if (this.studentDetails.studentClass.description != "Senior") {
        courses = courses.filter(
          (arr) => !(arr.crs_subj_cd == "CSC" && arr.crs_nbr == "405")
        );
      }

	//filter out CSC 430 if they didnt have CSC 366
      if (!this.studentDetails.courses.includes('CSC 366')) {
        courses = courses.filter(
          (arr) => !(arr.crs_subj_cd == "CSC" && arr.crs_nbr == "430")
        );
      }

	//filter out CSC 437 
      //if (!(this.studentDetails.courses.includes('CSC 275') && this.studentDetails.courses.includes('CSC 367'))) {
      if (!(this.studentDetails.courses.includes('CSC 302') && this.studentDetails.courses.includes('CSC 367'))) {
        courses = courses.filter(
          (arr) => !(arr.crs_subj_cd == "CSC" && arr.crs_nbr == "437")
        );
      }

	//filter out CSC 438
      //if (!(this.studentDetails.courses.includes('CSC 366') && this.studentDetails.courses.includes('CSC 367') && this.studentDetails.courses.includes('CSC 368'))) {
      if (!(this.studentDetails.courses.includes('CSC 366'))) {
        courses = courses.filter(
          (arr) => !(arr.crs_subj_cd == "CSC" && arr.crs_nbr == "438")
        );
      }

       //filter out CSC 478 if they didnt have CSC 275 and not senior
      //if (!(this.studentDetails.courses.includes('CSC 275') && this.studentDetails.studentClass.description == "Senior")) {
      if (!(this.studentDetails.courses.includes('CSC 385') && this.studentDetails.studentClass.description == "Senior")) {
        courses = courses.filter(
          (arr) => !(arr.crs_subj_cd == "CSC" && arr.crs_nbr == "478")
        );
      }

	//filter out CSC 479 if they didnt have CSC 385
      if (!this.studentDetails.courses.includes('CSC 385')) {
        courses = courses.filter(
          (arr) => !(arr.crs_subj_cd == "CSC" && arr.crs_nbr == "479")
        );
      }

	//filter out CSC 482
      //if (!(this.studentDetails.courses.includes('CSC 275') && this.studentDetails.courses.includes('CSC 302') && this.studentDetails.courses.includes('MAT 121') && this.studentDetails.courses.includes('CSC 385') && (this.studentDetails.courses.includes('MAT 113') || this.studentDetails.courses.includes('MAT 115')))) {
      if (!(this.studentDetails.courses.includes('CSC 385'))) {
        courses = courses.filter(
          (arr) => !(arr.crs_subj_cd == "CSC" && arr.crs_nbr == "482")
        );
      }

   }
/*
*/
//#######################################################################################################
      //FIN

      //filter out FIN302 if not eligible
      if (this.studentDetails.fin302_eligible == false) {
        var filteredFin302Courses = courses.filter(
          (arr) => arr.crs_subj_cd == "FIN" && arr.crs_nbr != 302
        );
        courses = courses.filter((arr) => arr.crs_subj_cd != "FIN");
        courses = [].concat(courses, filteredFin302Courses);
      }
      //filter out FIN302 online - all fin courses that are not fin 302 online - Disabled on 3-26-24 per Nancy H
      /*
      else {
        if (this.studentDetails.cbm_online == false) {
          var filteredFin302OnlineCourses = courses.filter(
            (arr) =>
              arr.crs_subj_cd == "FIN" &&
              !(arr.crs_nbr == 302 && arr.sched_type_desc == "Online")
          );
          courses = courses.filter((arr) => arr.crs_subj_cd != "FIN");
          courses = [].concat(courses, filteredFin302OnlineCourses);
        }
      }
      */

      return courses;
    },
    groupByFys(courses) {
      let fysGroup = this.groupBy(courses, "freshman_seminar_cd");
      Object.keys(fysGroup).forEach((key) => {
        fysGroup[key] = this.sortCourses(
          this.groupBy(fysGroup[key], "crs_subj_cd")
        );
      });
      return fysGroup;
    },
    groupByGened(courses) {
      let filter = courses.filter((element) => element.gened_attr_names != "");
      let fGroup = this.groupBy(filter, "gened_attr_names");
      let newGroup = new Object();
      Object.keys(fGroup).forEach((key) => {
        let values = fGroup[key];
        let keyArr = key.split("|");
        keyArr.forEach((gKey) => {
          if (typeof newGroup[gKey] != "undefined") {
            newGroup[gKey] = newGroup[gKey].concat(values);
          } else {
            newGroup[gKey] = values;
          }
        });
      });
      Object.keys(newGroup).forEach((key) => {
        let sortCourse = this.sortCourses(
          this.groupBy(newGroup[key], "crs_subj_cd")
        );
        newGroup[key] = sortCourse;
      });
      return newGroup;
    },
    groupByEcce(courses) {
      let filter = courses.filter((element) => element.ecce_attr_names != "");
      let fGroup = this.groupBy(filter, "ecce_attr_names");
      let newGroup = new Object();
      Object.keys(fGroup).forEach((key) => {
        let values = fGroup[key];
        let keyArr = key.split("|");
        keyArr.forEach((gKey) => {
          if (typeof newGroup[gKey] != "undefined") {
            newGroup[gKey] = newGroup[gKey].concat(values);
          } else {
            newGroup[gKey] = values;
          }
        });
      });
      Object.keys(newGroup).forEach((key) => {
        let sortCourse = this.sortCourses(
          this.groupBy(newGroup[key], "crs_subj_cd")
        );
        newGroup[key] = sortCourse;
      });
      return newGroup;
    },
    async getCourses() {
      this.$store.commit("status/setStatus", {
        snack: true,
        snackColor: "info",
        snackText: "Please wait while we fetch list of courses...",
      });
      await axios
        .get("/api/v1/courseslookup/" + this.selectedTerm)
        .then((response) => {
          this.$store.commit("courses/setAll", response.data);
          this.$store.commit(
            "courses/setAll",
            this.filterCoursesByPlacements(response.data)
          );
          this.groupedCourses = this.generateCourseGrouping(this.courses);
          if (this.isAdmin == true) {
            this.getSelectionsByUin(this.studentId);
          } else {
            this.getSelectionsByUin(this.studentId);
          }
        })
        .catch((error) => {
 		if(error.response && error.response.status === 401)
                    {
        this.$store.commit("status/setStatus", {
        snack: true,
        snackColor: "error",
        snackText: "Unauthorized - Please close your browser and log in again.",
      });
                    }	
		});
    },
    generateCourseGrouping(courses) {
      let newGroup = [];
      let fys = courses.filter(
        (element) => element.freshman_seminar_cd != null
      );
      let online = courses.filter(
        (element) => element.sched_type_desc == "Online"
      );
      newGroup["fys"] = this.sortCourses(this.groupBy(fys, "crs_subj_cd"));
      newGroup["online"] = this.sortCourses(
        this.groupBy(online, "crs_subj_cd")
      );
      newGroup["gened"] = this.groupByGened(courses);
      newGroup["ecce"] = this.groupByEcce(courses);
      newGroup[null] = this.sortCourses(this.groupBy(courses, "crs_subj_cd"));
      return newGroup;
    },
    async getSelectionsByUin(uin) {
      this.$store.commit("status/setStatus", {
        snack: true,
        snackColor: "info",
        snackText: "Retrieving already selected courses...",
      });
      await axios
        .get(
            "/api/v1/tentativecourseslookup/" +
            uin +
            "/" +
            this.selectedTerm
        )
        .then((response) => {
          if (this.isAdmin == true && response.data.length == 0) {
            this.exisitingSelections = [];
            this.selections = [];
            this.$store.commit("status/setStatus", {
              snack: true,
              snackColor: "error",
              snackText:
                "There are no selections for the searched UIN. Please drag and submit selections",
            });
          } else {
            this.$store.commit("courses/setTentative", response.data);
            this.selections = this.exisitingSelections.map(function (item) {
              return item.cdmallcoursessectplus;
            });
          }
        })
        .catch((error) => {});
    },
    async getCompleted() {
      this.$store.commit("status/setStatus", {
        snack: true,
        snackColor: "info",
        snackText: "Retrieving completed status..",
      });
      await axios
        .get(
            "/api/v1/completedapi/" +
            this.studentDetailsFromStore.currentStudentUin +
            "/" +
            this.termFromStore.selected
        )
        .then((response) => {
          this.is_complete = response.data.status;
        })
        .catch((error) => {});
      this.is_complete_disabled = false;
    },
    async updateHold() {
      if (
        confirm(
          "Are you sure you want to lift the traditional student advising hold?"
        )
      ) {
        await axios
          .post("/api/v1/completedapi", {
            term_cd: this.selectedTerm,
            uin: this.studentId,
            checked: this.is_complete,
            total_credits: this.studentDetails.total_credits,
            created_by: this.created_by,
          })
          .then((response) => {
            if (response.data.message == "Success") {
            } else {
              alert("An error occurred updating the hold.");
            }
          })
          .catch((error) => {
            alert("Something went wrong, hold could not be updated.");
          });
      } else {
      }
      this.is_complete_disabled = true;
      this.getCompleted();
    },

    async storeSelectedCourses() {
      if (this.isAdmin == "true") {
        var uin = this.searchUin;
        var isadmin = "true";
        if (uin == "") {
          alert("Search UIN is empty");
          return;
        }
      } else {
        var uin = this.studentId;
        var isadmin = "false";
      }

      let newSelections = this.selections.filter(
        (o) => !this.exisitingSelections.find((o2) => o.crn === o2.crn)
      );

      if (newSelections.length <= 0) {
        this.$store.commit("status/setStatus", {
          snack: true,
          snackColor: "info",
          snackText: "There are no new selections",
        });
        return;
      }

      await axios
        .post("/api/v1/storetentativecoursesapi", {
          uin: uin,
          courses: newSelections,
          isadmin: isadmin,
          created_by: this.created_by,
        })
        .then((response) => {
          // Event.$emit("current-term-schedule", this.studentId);
          this.$store.commit("status/setStatus", {
            snack: true,
            snackColor: "success",
            snackText: "Your course selections have been saved",
          });

          // this.exisitingSelections = response.data;
          this.$store.commit("courses/setTentative", response.data);

          this.selections = response.data.map(function (item) {
            return item.cdmallcoursessectplus;
          });
        })
        .catch((error) => {
          alert("Something went wrong, selections could not be submitted");
        });
    },

    async approveSelection(selection_id) {
      await axios
        .post(
            "/api/v1/approvetentativecoursesapi/" +
            selection_id
        )
        .then((response) => {
          if (response.data.approved == 1) {
            if (response.data.banneraudit && response.data.banneraudit.length) {
              this.bannerMessage = JSON.parse(
                response.data.banneraudit[response.data.banneraudit.length - 1]
                  .log
              ).message;
            }
            this.$store.commit("status/setStatus", {
              snack: true,
              snackColor: "success",
              snackText: "Course Selection Accepted: " + this.bannerMessage,
            });
            this.exisitingSelections.forEach((element, key) => {
              if (element.crn == response.data.crn) {
                this.exisitingSelections[key]["approved"] = 1;
              }
            });
          } else {
            alert("Something went wrong, approval could not be updated.");
          }
        })
        .catch((error) => {
          this.$store.commit("status/setStatus", {
            snack: true,
            snackColor: "error",
            snackText:
              "Something went wrong, selections could not be approved: " +
              error.response.data.errors.approve[0],
          });
        });
    },
    async getSemesters() {
      await axios
        .get("/api/v1/semesterlookup")
        .then((response) => {
          // this.termList = response.data;
          this.$store.commit("term/setAll", response.data);
          if (this.admin == "true" && this.lookupsemester) {
            this.$store.commit("term/setSelected", this.lookupsemester);
          } else {
            this.$store.commit(
              "term/setSelected",
              this.termList.current_semester
            );
          }
          // Event.$emit("selected-term", this.selectedTerm);
        })
        .catch((error) => {
          this.$store.commit("status/setStatus", {
            snack: true,
            snackColor: "error",
            snackText: "Something went wrong, semesters could not be retrieved",
          });
        });
    },
    setSelectedterm(event) {
      if (event.target.value != "") {
        this.$store.commit("term/setSelected", event.target.value);
      }
    },
  },
};
</script>
